import styled from 'styled-components';
import { DSButton } from '@engenharia/ds-react';
import colors from '../../../styles/theme/colors';

const ButtonStyled = styled(DSButton)`
  margin-top: ${(props) => (props.mt ? `calc(4px * ${props.mt})` : '0')};
  width: ${(props) => (props.fullWidth ? '100%' : 'initial')};
  border-width: 2px;

  &.green-button {
    background-color: ${(props) => (props.disabled === false ? colors.green[500] : '')};
  }
`;

const WrapperIcon = styled.div`
  display: flex;
  align-items: center;

  svg {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
`;

export { ButtonStyled, WrapperIcon };
